import { Grid } from '@mui/material';
import SupportAgentIcon from '@mui/icons-material/SupportAgent';
import { Accordion } from '../../../../../components/general/accordion';
import FieldText from '../../../../../components/general/fields/fieldText';

import { isNoSelected } from '../../form/functionaryInfo/formData';
import RichText from '../../../../../components/richText';
import { FunctionarySwitchProps } from './prop';
import { useFunctionarySwitchDetail } from './hook';

const fmtYesNo = (v?: string) => {
    const val = (v || '').toLowerCase().trim();
    if (val === 'si') return 'Sí';
    if (val === 'no') return 'No';
    return v || '';
};

export const FunctionarySwitchDetail = ({
    functionarySwitchDetail,
}: FunctionarySwitchProps) => {
    const { formik } = useFunctionarySwitchDetail(functionarySwitchDetail);

    return (
        <Accordion
            title="INFORMACIÓN FUNCIONARIO"
            icon={<SupportAgentIcon sx={{ color: 'primary.main' }} />}
            defaultExpanded={true}
            mt={2}
        >
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            >
                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Área:"
                        name="area"
                        size="small"
                        value={formik.values.area}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Funcionario:"
                        name="functionary"
                        size="small"
                        value={formik.values.functionary}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Correo funcionario:"
                        name="emailFunctionary"
                        size="small"
                        value={formik.values.emailFunctionary}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="Extensión:"
                        name="extFunctionary"
                        size="small"
                        value={formik.values.extFunctionary}
                        disabled
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FieldText
                        label="¿Atendió la llamada?"
                        name="functionaryAttendedCall"
                        size="small"
                        value={fmtYesNo(formik.values.functionaryAttendedCall)}
                        disabled
                    />
                </Grid>

                {isNoSelected(formik.values.functionaryAttendedCall) && (
                    <Grid item xs={12}>
                        <RichText
                            initialContent={formik.values.templateEmail}
                            editable={false}
                            onContentChange={(value: string) =>
                                formik.setFieldValue('templateEmail', value)
                            }
                        />
                    </Grid>
                )}
            </Grid>
        </Accordion>
    );
};
